import { Faq } from './Faq';
import { Features } from './Features';
import { PricingSection } from './PricingSection';
import { PricingTeaser } from './PricingTeaser';

export { Faq, Features, PricingSection, PricingTeaser };
